var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63194 11.6089C2.03777 10.6186 2.03777 9.38143 2.63194 8.39114V8.39114C2.81326 8.08895 3.11364 7.87726 3.45921 7.80815L4.87006 7.52598C4.95412 7.50917 5.02989 7.46409 5.08476 7.39824L6.33747 5.89498C7.52003 4.47592 8.11131 3.76638 8.63897 3.95742C9.16663 4.14846 9.16663 5.07207 9.16663 6.91928L9.16663 13.0807C9.16663 14.9279 9.16663 15.8515 8.63897 16.0426C8.11131 16.2336 7.52003 15.5241 6.33747 14.105L5.08476 12.6018C5.02989 12.5359 4.95412 12.4908 4.87007 12.474L3.45921 12.1918C3.11364 12.1227 2.81326 11.9111 2.63194 11.6089V11.6089Z",
    stroke: "#0573E4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volumeOff.46fc0b14fcdd1a0dd6af74c876dc3b6d.svg";
export { ForwardRef as ReactComponent };